import { render, staticRenderFns } from "./NightProvider.vue?vue&type=template&id=956454bc&"
import script from "./NightProvider.vue?vue&type=script&lang=js&"
export * from "./NightProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports